import { Component, ChangeDetectionStrategy } from '@angular/core';

import { HandleBookingService } from '../../services/handle-booking.service';
import { TranslocoModule } from '@jsverse/transloco';
import { BookingConfigService } from '../../services/booking-config.service';
import { MyOrderDetailsComponent } from './my-order-details/my-order-details.component';
import { SelfServiceService } from '../../../services/self-service.service';
import { AsyncPipe, DatePipe } from '@angular/common';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TopNavbarComponent } from '../../organizations/components/top-navbar/top-navbar.component';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-my-orders',
  imports: [
    MyOrderDetailsComponent,
    TranslocoModule,
    MatProgressBarModule,
    DatePipe,
    MatCardContent,
    TopNavbarComponent,
    MatIcon,
    MatCard,
    AsyncPipe
],
  providers: [HandleBookingService],
  templateUrl: './my-orders.component.html',
  styleUrl: './my-orders.component.css',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    'style': 'font-family: Inter, sans-serif;'
  }
})
export class MyOrdersComponent {
  isLoading: boolean = true;
  orderList: any = [];
  site: string = ""
  displayName: string = "";
  showError: boolean = false;

  constructor(
    private router: Router,
    public authService: AuthService,
    private bookingConfigService: BookingConfigService,
    private selfService: SelfServiceService
  ) {
    const config = this.bookingConfigService.getConfig();
    this.site = config.site;
  }

  ngOnInit() {
    this.isLoading = true;
    this.showError = false;

    if (!this.authService.loggedIn()) {
      this.router.navigate(['parkifly', this.site]);
    }
    this.displayName = this.authService.displayName.split(' ')[0];
    this.selfService.getOrderListByAuthor().then(orderList => {
      this.orderList = orderList || [];
      this.isLoading = false;
    },
      error => {
        this.isLoading = false;
        this.showError = true;
      });
  }

  goToBooking(organization: string) {
    if (organization === 'aiden') {
      this.router.navigate(['/parkifly/aiden-landing-page'], { queryParams: { public: 'true' } });
    } else {
      this.router.navigate(['parkifly', organization]);
    }
  }
}